import { useEffect, useState } from "react";

import { Grid } from "@/components";
import {
  BREAKPOINT_1,
  BREAKPOINT_2,
  BREAKPOINT_3,
  BREAKPOINT_5,
} from "@/const";
import { useAppProperties } from "@/hooks";
import { useCommunityGroups, useTranslate } from "@/providers/context";

import { CommunityGroupCard } from "../";

const Header = ({ title }: { title: string }) => {
  return (
    <div className="h5-bold mb-3 flex h-[38px] items-center capitalize">
      {title}
    </div>
  );
};

export const CommunityGroups = () => {
  const { translate } = useTranslate();
  const [colsPerRow, setColsPerRow] = useState({ large: 3, small: 6 });

  const { groups } = useCommunityGroups();
  const { data: properties } = useAppProperties();

  const { joined, not_joined } = groups ?? { joined: [], not_joined: [] };

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width > BREAKPOINT_5) {
        setColsPerRow({ large: 4, small: 6 });
      } else if (width >= BREAKPOINT_3) {
        setColsPerRow({ large: 3, small: 6 });
      } else if (width >= BREAKPOINT_2) {
        setColsPerRow({ large: 3, small: 4 });
      } else if (width >= BREAKPOINT_1) {
        setColsPerRow({ large: 3, small: 4 });
      } else {
        setColsPerRow({ large: 2, small: 3 });
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="flex w-full flex-col gap-y-[52px] px-7 pb-10">
      {joined.length > 0 && (
        <div>
          <Header
            title={`${translate("Your")} ${properties?.CommunityGroupLabelPlural ?? translate("Groups")}`}
          />
          <Grid
            overrideColsPerRow={
              joined.length > 6 ? colsPerRow.small : colsPerRow.large
            }
          >
            {joined.map((group) => (
              <CommunityGroupCard key={group.CommunityID} group={group} />
            ))}
          </Grid>
        </div>
      )}
      {not_joined.length > 0 && (
        <div>
          <Header title={translate("Discover")} />
          <Grid overrideColsPerRow={colsPerRow.small}>
            {not_joined.map((group) => (
              <CommunityGroupCard key={group.CommunityID} group={group} />
            ))}
          </Grid>
        </div>
      )}
    </div>
  );
};
